import React, {useContext, useEffect, useState} from "react";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {Box, IconButton} from "@mui/material";
import {Lock, LockOpen, LockOutlined} from "@mui/icons-material";
import {connect} from "react-redux";
import {selectLocks} from "../../redux/selectors/firebase";
import {selectUserId} from "../../redux/selectors/editor";

export type Locks = {[state: string]: ILock};
interface ILock {
    user: string
    created: number
}
interface IProps {
    locks: Locks
    onChange?: (locked: boolean, user?: string) => void
    project: string
    size: "small" | "medium"
    state: string
    user: string
}
function StateLock({locks, onChange, project, size, state, user}: IProps) {
    const [locked, setLocked] = useState(false);
    const [lockTitle, setLockTitle] = useState("");
    const {get, removeLock, setLock} = useContext(FirebaseContext);
    const handleClickLock = () => {
        if (locked && user === locks[state].user) {
            removeLock(project, state!).then(() => {
                onChange && onChange(false);
                setLocked(false);
            });
        } else {
            setLock(project, state!, user).then(() => {
                setLocked(true);
                onChange && onChange(true, user);
            });
        }
    }
    const lockIcon = locked ? ((locks && locks[state]?.user) === user ? <Lock/> : <LockOutlined/>) : <LockOpen/>;
    const lockDisabled = locks && locks[state] && (locks[state].user !== user);

    useEffect(() => {
        if (! locks) return;
        const lock = locks[state];

        if (lock) {
            const date = new Date(lock.created * 1000);

            setLocked(true);
            setLockTitle(`Locked on ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`);
            get(`users/${lock.user}/name`).then(name => {
                if (name) {
                    setLockTitle(`Locked by ${name} on ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`);
                }
            });
        } else {
            setLocked(false);
            setLockTitle(`Unlocked, select to lock and make structural changes`);
        }
    }, [get, locks, state]);
    return (
        <Box title={lockTitle}>
            <IconButton color="inherit" onClick={handleClickLock} size={size} disabled={lockDisabled}>
                {lockIcon}
            </IconButton>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    locks: selectLocks(store) ?? {},
    user: selectUserId(store)
});

export default connect(mapStateToProps, {
})(StateLock);